import { connect } from "react-redux";
import InitComponent from "../Components/InitComponent";
import { setActiveTenant, setPartnerTenants } from "../Redux/Actions/activeTenantActions";
import { setLicences, setAvailableLicences } from "../Redux/Actions/LicencesActions";
import { setScopes } from "../Redux/Actions/ScopesActions";
import { setScopesNames, setRoles, setAllRoles, setPermissions } from "../Redux/Actions/ScopesActions";
import { setMedias } from "../Redux/Actions/MediaActions";
import { setAgents, setAgentsIds } from "../Redux/Actions/AgentsActions";
import { setCallFlows } from "../Redux/Actions/CallFlowActions";
import { setAgentAIs } from "../Redux/Actions/AgentAIActions";
import { setAgentProfiles } from "../Redux/Actions/AgentProfileActions";
import { setAnalyticsProfiles } from "../Redux/Actions/AnalyticsActions";
import { setQueues } from "../Redux/Actions/QueuesActions";
import { setChatFlows, setWhatsAppFlows } from "../Redux/Actions/ChatFlowActions";
import { setGroups } from "../Redux/Actions/GroupsActions";
import { setVariables, setWorkflows } from "../Redux/Actions/VariablesWorkflowsActions";
import { setSupervisedAgentDetails, setSupervisedAgentIds, setCallFlowsIds } from "../Redux/Actions/RecordingActions";

// Inline consent action
const setConsentedApps = (apps) => ({
  type: "SET_CONSENTED_APPS",
  payload: apps
});

// bootstrapMode : aucun droit + tenant non consenti (tenant neuf) → proposer l'onboarding.
const setBootstrapMode = (bootstrapMode) => ({
  type: "SET_BOOTSTRAP_MODE",
  payload: bootstrapMode
});
const mapStateToProps = (state) => ({
  ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
  LICENCES: state.reducer.LICENCES,
  SCOPES: state.reducer.SCOPES,
  SCOPES_NAMES: state.reducer.SCOPES_NAMES,
  bootstrapMode: state.reducer.bootstrapMode
});
const mapDispatchToProps = (dispatch) => ({
  setActiveTenant: (ACTIVE_TENANT) => dispatch(setActiveTenant(ACTIVE_TENANT)),
  setLicences: (LICENCES) => dispatch(setLicences(LICENCES)),
  setScopes: (SCOPES) => dispatch(setScopes(SCOPES)),
  setScopesNames: (SCOPES_NAMES) => dispatch(setScopesNames(SCOPES_NAMES)),
  setMedias: (MEDIAS) => dispatch(setMedias(MEDIAS)),
  setAvailableLicences: (SCOPE_AVAILABLE_LICENCES) => dispatch(setAvailableLicences(SCOPE_AVAILABLE_LICENCES)),
  setAgents: (AGENTS) => dispatch(setAgents(AGENTS)),
  setAgentsIds: (AGENTS_IDS) => dispatch(setAgentsIds(AGENTS_IDS)),
  setCallFlows: (CALL_FLOWS) => dispatch(setCallFlows(CALL_FLOWS)),
  setAgentAIs: (agentAIs) => dispatch(setAgentAIs(agentAIs)),
  setAgentProfiles: (AGENT_PROFILES) => dispatch(setAgentProfiles(AGENT_PROFILES)),
  setAnalyticsProfiles: (ANALYTICS_PROFILES) => dispatch(setAnalyticsProfiles(ANALYTICS_PROFILES)),
  setQueues: (QUEUES) => dispatch(setQueues(QUEUES)),
  setChatFlows: (chatFlows) => dispatch(setChatFlows(chatFlows)),
  setWhatsAppFlows: (whatsAppFlows) => dispatch(setWhatsAppFlows(whatsAppFlows)),
  setRoles: (ROLES) => dispatch(setRoles(ROLES)),
  setAllRoles: (ROLES) => dispatch(setAllRoles(ROLES)),
  setGroups: (GROUPS) => dispatch(setGroups(GROUPS)),
  setPermissions: (PERMISSIONS) => dispatch(setPermissions(PERMISSIONS)),
  setConsentedApps: (apps) => dispatch(setConsentedApps(apps)),
  setBootstrapMode: (v) => dispatch(setBootstrapMode(v)),
  setSupervisedAgentDetails: (supervisedAgentDetails) => dispatch(setSupervisedAgentDetails(supervisedAgentDetails)),
  setSupervisedAgentIds: (supervisedAgentIds) => dispatch(setSupervisedAgentIds(supervisedAgentIds)),
  setCallFlowsIds: (callFlowsIds) => dispatch(setCallFlowsIds(callFlowsIds)),
  setPartnerTenants: (partnerTenants) => dispatch(setPartnerTenants(partnerTenants)),
  setVariables: (variables) => dispatch(setVariables(variables)),
  setWorkflows: (workflows) => dispatch(setWorkflows(workflows))
});

export default connect(mapStateToProps, mapDispatchToProps)(InitComponent);
